document.addEventListener('DOMContentLoaded', () => {
  // if (document.querySelector('.mobileNav__list .menu-item-has-children')) {
  //   let subMenus = document.querySelectorAll(
  //     '.mobileNav__list .menu-item-has-children'
  //   );
  //   subMenus.forEach((subMenu) => {
  //     let link = subMenu.querySelector('a');
  //     let span = subMenu.querySelector('span');
  //     let ul = subMenu.querySelector('ul');
  //     link.addEventListener('click', (e) => {
  //       if (subMenu.querySelector('span')) {
  //         e.preventDefault();
  //         ul.classList.toggle('sub-menu--open');
  //         span.classList.toggle('open');
  //       }
  //     });
  //   });
  // }
  const hamburgers = document.querySelectorAll('.hamburger');
  const mobileNav = document.querySelector('.header__nav');
  hamburgers.forEach(hamburger => {
    hamburger.addEventListener('click', () => {
      hamburgers.forEach(h => {
        h.classList.toggle('hamburger--opened');
        h.setAttribute(
          'aria-expanded',
          h.classList.contains('hamburger--opened')
        );
      })
      mobileNav.classList.toggle('open');
      if (document.querySelector('.mobileNav__list .menu-item-has-children') && !hamburger.classList.contains('hamburger--opened')) {
        let subMenus = document.querySelectorAll(
          '.mobileNav__list .menu-item-has-children'
        );

        subMenus.forEach((subMenu) => {
          let span = subMenu.querySelector('span');
          let ul = subMenu.querySelector('ul');
          ul.classList.remove('sub-menu--open');
          span.classList.remove('open');

        });
      }
    });

  });
  // klik w pozycję menu mobilnego (w tym kotwice #) zamyka nakładkę
  const mobileNavItems = document.querySelectorAll('.header__nav a')
  if (mobileNavItems)
    mobileNavItems.forEach(mobileNavItem => {
      mobileNavItem.addEventListener('click', (e) => {
        if (e.target.classList.contains('menu-item-open-submenu') || e.target.parentNode.classList.contains('menu-item-open-submenu'))
          return
        if (!mobileNav.classList.contains('open'))
          return
        hamburgers.forEach(h => {
          h.classList.remove('hamburger--opened');
          h.setAttribute('aria-expanded', 'false');
        })
        mobileNav.classList.remove('open');
      })
    });

  const header = document.querySelector('.header');

  const btn = document.querySelector('.scrollTop');

  var lastPosition = document.documentElement.scrollTop;
  var direction = 'down';
  window.addEventListener('scroll', () => {

    if (lastPosition < document.documentElement.scrollTop)
      direction = 'down'
    else if (lastPosition > document.documentElement.scrollTop)
      direction = 'up';
    // pozycja bez zmian -> kierunek bez zmian


    if (direction == 'up' || mobileNav.classList.contains('open')) {
      header.classList.add('header--scrolled');
      header.classList.remove('header--hidden');
    }
    else {
      header.classList.add('header--hidden');
    }

    // pływająca strzałka do góry: widoczna przy scrollu w górę (poza samą górą),
    // znika przy scrollu w dół
    if (btn) {
      const y = document.documentElement.scrollTop;
      if (direction == 'up' && y > 300) {
        btn.classList.remove('scrollTop--hidden');
      } else {
        btn.classList.add('scrollTop--hidden');
      }
    }

    lastPosition = document.documentElement.scrollTop;
    if (!(document.body.scrollTop > 120 || document.documentElement.scrollTop > 120)) {
      header.classList.remove('header--scrolled');
      header.classList.remove('header--hidden');
      setTimeout(() => {
        header.style.position = "absolute"
      }, 300)
    } else {
      header.style.position = "fixed"
    }
  });


  if (btn) btn.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });

  // Rejestracja: pola firmowe (nazwa firmy, NIP, wielkość) widoczne tylko,
  // gdy w przełączniku "Czy reprezentujesz firmę?" wybrano "Tak".
  const companyFields = document.querySelector('[data-company-fields]');
  const toggleControl = document.querySelector('.gff-toggle');
  if (companyFields && toggleControl) {
    const radios = toggleControl.querySelectorAll('input[type="radio"]');
    const syncCompanyFields = () => {
      const checked = Array.from(radios).find((r) => r.checked);
      companyFields.hidden = !(checked && checked.value === 'Tak');
    };
    radios.forEach((r) => r.addEventListener('change', syncCompanyFields));
    syncCompanyFields();
  }

  // Po udanej wysyłce formularza rejestracji pokazujemy popup podziękowania
  // (fallback: strona /dziekujemy/, gdy popupu nie ma w DOM)
  const thanksPopup = document.querySelector('.gff-thanks-popup');
  document.addEventListener('wpcf7mailsent', () => {
    if (!thanksPopup) {
      window.location.href = '/dziekujemy/';
      return;
    }
    thanksPopup.removeAttribute('hidden');
    requestAnimationFrame(() => thanksPopup.classList.add('is-open'));
    document.body.style.overflow = 'hidden';
  });
  if (thanksPopup) {
    const closeThanks = () => {
      thanksPopup.classList.remove('is-open');
      thanksPopup.setAttribute('hidden', '');
      document.body.style.overflow = '';
    };
    thanksPopup.querySelector('.gff-thanks-popup__close').addEventListener('click', closeThanks);
    thanksPopup.querySelector('.gff-thanks-popup__overlay').addEventListener('click', closeThanks);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !thanksPopup.hasAttribute('hidden')) closeThanks();
    });
  }

})
